import { GetHomeScreenBanner, GetHomeScreenBannerVariables } from './__generated__/GetHomeScreenBanner'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query GetHomeScreenBanner($id: String!) {
    homeScreenBanner: homeScreenBannerV2(id: $id) {
      ... on HomeScreenBannerV2 {
        id
        title
        description
        backgroundColor
        positionInFeed
        enabled
        buttons {
          title
          deepLinkUrl
        }
        imageUrl
      }
      ... on HomeScreenBannerErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetHomeScreenBanner = (variables: GetHomeScreenBannerVariables) =>
  useQuery<GetHomeScreenBanner, GetHomeScreenBannerVariables>(QUERY, { variables })
